module.exports = __webpack_public_path__ + "static/media/ashish.1d991423.png";